export default __webpack_public_path__ + "static/media/214.f3808b3a.png";